import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {StyleService, StyleType} from '../../services/style.service';

@Component({
    selector: 'app-nfc-accepted',
    templateUrl: './nfc-accepted.component.html',
    styleUrls: ['./nfc-accepted.component.scss'],
})
export class NfcAcceptedComponent implements OnInit {
    public readonly StyleType = StyleType;

    @Input()
    interval: any;
    state;
    baseTime = 20;
    timer = this.baseTime;

    constructor(
        private modalCtrl: ModalController,
        public styleService: StyleService
    ) { }

    ngOnInit() {
        this.setTimer();
    }

    dismiss() {
        clearInterval(this.interval);
        this.modalCtrl.dismiss({})
    }
    setTimer() {
        clearInterval(this.interval)
        this.timer = this.baseTime;
        this.interval = setInterval(() => {
            this.timer--;
            if (this.timer <= 0) {
                clearInterval(this.interval)
                this.dismiss()
            }
        }, 1000)
    }
}
